import {
  DxpDataLayerEvent,
  DxpDataLayerType,
} from "./customDatalayerInterface";
import { CustomDxpWindow } from "./custom.window";
import dxpDataLayerToggleVerification from "./dxpDataLayerToggleVerification";
import { getReferrer } from './dataLayerHelpers'

declare let window: CustomDxpWindow;

const dxpDigitalDataAssignment = (
  data: DxpDataLayerType,
  jlrDataLayer = false
) => {
  const isDxpDataLayer = dxpDataLayerToggleVerification();
  if (isDxpDataLayer) {
    try {
      const lastIndex = window.dataLayer.length - 1;
      const lastEvent = window.dataLayer[lastIndex];
      const isLastIndex = jlrDataLayer
      ? lastEvent?.event === data.event &&
        (lastEvent?.click_text
          ? lastEvent?.click_text === data.click_text
          : false)
      : lastEvent?.eventName === data.eventName

      if (isLastIndex) {
        window.dataLayer[lastIndex] = {
          ...lastEvent,
          ...(!jlrDataLayer
            ? {
              event: DxpDataLayerEvent.CONFIGURATOR,
              pageTitle: document.title,
              pageName: window.location.pathname,
              pageLocation: window.location.pathname,
              referralPage: getReferrer().from,
            }
            : {}),
          ...data,
        };
      } else {
        window.dataLayer.push({
          ...(!jlrDataLayer
            ? {
              event: DxpDataLayerEvent.CONFIGURATOR,
              pageTitle: document.title,
              pageName: window.location.pathname,
              pageLocation: window.location.pathname,
              referralPage: getReferrer().from,
            }
            : {}),
          ...data,
        });
      }
    } catch (err) {
      // eslint-disable-next-line no-console
      console.log("DataLayer error", err);
    }
  }
};


export default dxpDigitalDataAssignment;
